var url = window.location.href;

console.log('themeMode',themeMode, url, 'url');

if(themeMode == '30%OFF'){
  if(url == 'https://medistik.com/' || url == 'https://medistik.com'){
    window.location.href = 'https://medistik.com/pages/v2-special-value';
  }
  // if(url == 'https://medistik.com/collections/products' || url == 'https://medistik.com/collections/products/'){
  //   window.location.href = '/collections/special-value-bundle';
  // }
}else if(themeMode == 'promo'){
  if(url == 'https://medistik.com/' || url == 'https://medistik.com'){
    window.location.href = 'https://medistik.com/pages/v1promo';
  }
  // if(url == 'https://medistik.com/collections/products' || url == 'https://medistik.com/collections/products/'){
  //   window.location.href = '/collections/special-value-bundle';
  // }
}


  if(url == 'https://medistik.com/pages/o' ){
    window.location.href = 'https://medistik.com';
  }
  if(url == 'https://medistik.com/collections/products-o' || url == 'https://medistik.com/collections/products-o/'){
    window.location.href = '/collections/products';
  }
  if(url == 'https://medistik.com/collections/value-bundles-o' || url == 'https://medistik.com/collections/value-bundles-o/'){
    window.location.href = '/collections/value-bundles';
  }
  // if(url == 'https://medistik.com/collections/special-value-bundle-o' || url == 'https://medistik.com/collections/special-value-bundle-o/'){
  //   window.location.href = '/collections/special-value-bundle';
  // }
  if(url == 'https://medistik.com/collections/pain-relief' || url == 'https://medistik.com/collections/pain-relief/'){
    window.location.href = '/collections/products';
  }
  if(url == 'https://medistik.com/collections/self-care' || url == 'https://medistik.com/collections/self-care/'){
    window.location.href = '/collections/products';
  }